import React from "react";
import {ButtonGroup} from "@mui/material";
import {
  EditCompanyProfileButton,
  EditCompanyProfileLabelText,
  EditCompanyProfileMarginTop20
} from "./EditCompanyProfile/style";

const ChargeModelButton = (props) => {
    const {useCalendarDays, setUseCalendarDays} = props;

    return (
      <EditCompanyProfileMarginTop20 item component={'section'} marginBottom={'1.43rem'}>
        <EditCompanyProfileLabelText variant={'subtitle1'} color={'textSecondary'}>Charge
          Model</EditCompanyProfileLabelText>
        <ButtonGroup>
          <EditCompanyProfileButton
            className={`d-flex ss-tab-btn`}
            onClick={() => setUseCalendarDays(false)}
            variant={!useCalendarDays ? "contained" : "outlined"}
            color={!useCalendarDays ? "primary" : "secondary"}
          >
            24 Hour
          </EditCompanyProfileButton>
          <EditCompanyProfileButton
            className={`d-flex ss-tab-btn`}
            onClick={() => setUseCalendarDays(true)}
            variant={useCalendarDays ? "contained" : "outlined"}
            color={useCalendarDays ? "primary" : "secondary"}
          >
            Calendar Days
          </EditCompanyProfileButton>
        </ButtonGroup>
      </EditCompanyProfileMarginTop20>
    )
}

export default ChargeModelButton;
